/* eslint-disable jsx-a11y/img-redundant-alt */
import "./style/Aboutus.css";
import Photo1 from "./image/photo1.jpg";
import Photo2 from "./image/photo2.jpg";
import Photo3 from "./image/photo4444.jpg";
import Photo4 from "./image/PHOTO4.jpg";
import photo5 from "./image/PHOTO5.jpg";
import photo6 from "./image/PHOTO6.jpg";
import { useTranslation } from "react-i18next";
const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="Text-Top">
        <h1 className="Text-About">{t("AboutA")}</h1>

        <h1 className="Text-About">{t("AboutB")}</h1>
        <div>
          <img src={Photo1} alt="image" className="image" />
        </div>

        <h1 className="Text-About">{t("AboutC")}</h1>
        <div>
          <img src={Photo2} alt="image" className="image" />
        </div>

        <h1 className="Text-About">{t("AboutD")}</h1>
        <div>
          <img src={Photo3} alt="image" className="image" />
        </div>
        <h1 className="Text-About">{t("AboutE")}</h1>
        <div>
          <img src={Photo4} alt="image" className="image" />
        </div>
        <h1 className="Text-About">{t("AboutF")}</h1>
        <h1 className="Text-About">{t("AboutH")}</h1>
        <h1 className="Text-About">{t("AboutI")}</h1>
        <h1 className="Text-About">{t("AboutJ")}</h1>
        <h1 className="Text-About">{t("AboutK")}</h1>
        {/* <h1 className="Text-About">{t("AboutK1")}</h1> */}
        <h1 className="Text-About">{t("AboutM")}</h1>

        <div>
          <img src={photo5} alt="image" className="image" />
        </div>
        <div>
          <img src={photo6} alt="image" className="image" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
